/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for the Credential model from the leaks database.
 * @export
 * @interface Credential
 */
export interface Credential {
    /**
     * 
     * @type {number}
     * @memberof Credential
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof Credential
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Credential
     */
    identifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Credential
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Credential
     */
    domainName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Credential
     */
    serviceName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Credential
     */
    isMobile?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Credential
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the Credential interface.
 */
export function instanceOfCredential(value: object): value is Credential {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CredentialFromJSON(json: any): Credential {
    return CredentialFromJSONTyped(json, false);
}

export function CredentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): Credential {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'] == null ? undefined : json['url'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'password': json['password'] == null ? undefined : json['password'],
        'domainName': json['domain_name'] == null ? undefined : json['domain_name'],
        'serviceName': json['service_name'] == null ? undefined : json['service_name'],
        'isMobile': json['is_mobile'] == null ? undefined : json['is_mobile'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

  export function CredentialToJSON(json: any): Credential {
      return CredentialToJSONTyped(json, false);
  }

  export function CredentialToJSONTyped(value?: Omit<Credential, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'identifier': value['identifier'],
        'password': value['password'],
        'domain_name': value['domainName'],
        'service_name': value['serviceName'],
        'is_mobile': value['isMobile'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

